import { useDialogsContext } from 'contexts/Dialogs/DialogsContext';
import React, { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

interface IUnsavedConfigBlockerProps {
	shouldBlock: boolean;
}

const UnsavedConfigBlocker: React.FC<IUnsavedConfigBlockerProps> = ({
	shouldBlock
}) => {
	const blocker = useBlocker(
		({ currentLocation, nextLocation }) =>
			shouldBlock && currentLocation.pathname !== nextLocation.pathname // check for cleanup of query params before "Test again"
	);

	const { openUnsavedNavigationDialog } = useDialogsContext();

	useEffect(() => {
		if (blocker.state !== 'blocked') return undefined;
		let cancelled = false;
		(async () => {
			const { proceed } = await openUnsavedNavigationDialog();
			if (cancelled) return;
			if (proceed) blocker.proceed?.();
			else blocker.reset?.();
		})();
		return () => {
			cancelled = true;
		};
	}, [blocker, openUnsavedNavigationDialog]);

	return null;
};

export default UnsavedConfigBlocker;
